import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const PROMO_PARAM = 'appPromo';
const ANDROID_WEB_PROMO_VALUE = 'android-web';

export function AndroidWebPromoModal() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    setIsVisible(location.pathname === '/' && params.get(PROMO_PARAM) === ANDROID_WEB_PROMO_VALUE);
  }, [location.pathname, location.search]);

  const closeModal = React.useCallback(() => {
    setIsVisible(false);

    const params = new URLSearchParams(location.search);
    params.delete(PROMO_PARAM);
    const nextSearch = params.toString();
    navigate(
      {
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
        hash: location.hash,
      },
      { replace: true }
    );
  }, [location.hash, location.pathname, location.search, navigate]);

  if (!isVisible || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/45 px-4 backdrop-blur-sm">
      <div
        className="relative w-full max-w-sm overflow-hidden rounded-2xl border border-sky-100 bg-white shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="android-web-promo-title"
      >
        <button
          type="button"
          onClick={closeModal}
          className="absolute right-3 top-3 z-10 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/85 text-glass-500 shadow-sm transition hover:bg-white hover:text-glass-900"
          aria-label="Bilgilendirme popupını kapat"
        >
          <X className="h-4 w-4" />
        </button>

        <div
          className="border-b border-sky-100 bg-sky-50 px-5 pb-5 pt-6 text-center"
          style={{
            backgroundImage:
              'repeating-linear-gradient(135deg, rgba(14,165,233,0.12) 0, rgba(14,165,233,0.12) 1px, transparent 1px, transparent 12px)',
          }}
        >
          <div className="mx-auto h-20 w-20 overflow-hidden rounded-2xl border border-white bg-white shadow-lg shadow-sky-700/10">
            <img src="/Arıza.webp" alt="Arıza Rehberim" className="h-full w-full object-contain" />
          </div>
          <p className="mt-3 text-base font-bold text-glass-900">ArızaRehberim</p>
          <p className="mt-1 text-xs font-semibold text-sky-700">Android uygulaması hazırlanıyor</p>
        </div>

        <div className="px-5 pb-5 pt-5 text-center">
          <h2 id="android-web-promo-title" className="text-xl font-bold leading-tight text-glass-900">
            Android için en hızlı yol
          </h2>

          <p className="mt-3 text-sm leading-6 text-glass-700">
            Şu an tüm özelliklerden buradan faydalanabilirsin.
          </p>

          <button
            type="button"
            onClick={closeModal}
            className="mt-5 inline-flex w-full items-center justify-center rounded-xl bg-gradient-to-r from-sky-600 to-emerald-600 px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-sky-700/20 transition hover:from-sky-700 hover:to-emerald-700"
          >
            Devam Et
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
